import React from 'react'
import Datetime from 'react-datetime'
import Select from 'react-select'
import { FormikProps } from 'formik'
import moment from 'moment'
import LocationSelectionMapModal from 'Presentation/Components/LocationSelectionMapModal/View'

import { InitialState as SurveyInitialState } from 'Store/Survey'
import clsx from 'clsx'

interface Props {
  isView: boolean
  formik: FormikProps<SurveyInitialState>
  saleOrders: any[]
  saleOrder: any
  handleOpenSelectLocation: () => void
  onChangeSaleOrderHeader: (id: number) => void
}

const SurveyFormHeader: React.FC<Props> = ({
  isView,
  formik,
  saleOrders,
  saleOrder,
  handleOpenSelectLocation,
  onChangeSaleOrderHeader,
}) => {
  return (
    <React.Fragment>
      <LocationSelectionMapModal />

      <div className='card'>
        <div className='card-header'>
          <div className='card-title'>
            <h4 className='mb-0'>บันทึกผลการสำรวจ</h4>
          </div>
        </div>

        <div className='card-body mb-5'>
          <div className='row gy-5'>
            {/* begin:: Sale Order No. */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='poNo' className='fs-6 mb-1 fw-bold'>
                Sale Order
                {/* <span className='required' /> */}
              </label>

              <Select
                id='saleOrderPointer'
                name='saleOrderId'
                isMulti={false}
                isClearable
                // isClearable={formik.values.saleOrderId !== null ? true : false}
                // isOptionDisabled={() => (isView || formik.values.saleOrderId ? true : false)}
                styles={{
                  control: (provided: any) => ({
                    ...provided,
                    borderColor: formik.errors.saleOrderId ? 'red' : '#e1e3ea',
                    pointerEvents: isView ? 'none' : 'auto',
                  }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                options={saleOrders}
                value={
                  saleOrders.find(option => option.value === formik.values.saleOrderId) ?? null
                }
                onChange={(option: any) => onChangeSaleOrderHeader(option?.value)}
              />

              {formik.touched?.saleOrderId && formik.errors?.saleOrderId && (
                <div className='fv-plugins-message-container mt-2'>
                  <div className='fv-help-block' style={{ fontSize: '14px', fontWeight: '500' }}>
                    {formik.errors?.saleOrderId}
                  </div>
                </div>
              )}
            </div>
            {/* end:: Sale Order No. */}

            {/* begin:: Start Job Date */}
            {/* <div className='col-12 col-xl-3'>
              <label htmlFor='date' className='fs-6 mb-1 fw-bold'>
                วันที่เริ่มงาน
              </label>

              <Datetime
                timeFormat={false}
                dateFormat='DD/MM/YYYY'
                className='filter-date-input w-100 z-4 pointer-events-none'
                renderInput={props => (
                  <input
                    {...props}
                    autoComplete='off'
                    name='startJobDate'
                    className='form-control form-control-sm'
                    placeholder='กรุณาเลือก Sale Order'
                    disabled
                  />
                )}
                value={
                  saleOrder?.startJobDate
                    ? moment(saleOrder?.startJobDate).format('DD/MM/YYYY')
                    : undefined
                }
              />
            </div> */}
            {/* end:: Start Job Date */}

            {/* begin:: End Job Date */}
            {/* <div className='col-12 col-xl-3'>
              <label htmlFor='date' className='fs-6 mb-1 fw-bold'>
                วันที่สิ้นสุดงาน
              </label>

              <Datetime
                timeFormat={false}
                dateFormat='DD/MM/YYYY'
                className='filter-date-input w-100 z-4 pointer-events-none'
                renderInput={props => (
                  <input
                    {...props}
                    autoComplete='off'
                    name='endJobDate'
                    className='form-control form-control-sm'
                    placeholder='กรุณาเลือก Sale Order'
                    disabled
                  />
                )}
                value={
                  saleOrder?.endJobDate
                    ? moment(saleOrder?.endJobDate).format('DD/MM/YYYY')
                    : undefined
                }
              />
            </div> */}
            {/* end:: End Job Date */}

            {/* begin:: Seller */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='sellerId' className='fs-6 mb-1 fw-bold'>
                ผู้ขาย
              </label>

              <input
                className='form-control form-control-sm'
                placeholder=''
                {...formik.getFieldProps('saleTitle')}
                disabled={isView}
              />
            </div>
            {/* end:: Seller */}

            {/* begin:: Department */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='department' className='fs-6 mb-1 fw-bold'>
                หน่วยงาน
              </label>

              <input
                className='form-control form-control-sm'
                placeholder=''
                {...formik.getFieldProps('division')}
                disabled={isView}
              />
            </div>
            {/* end:: Department */}

            {/* begin:: Customer */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='customerName' className='fs-6 mb-1 fw-bold'>
                ชื่อลูกค้า
              </label>

              <input
                className={clsx('form-control form-control-sm', {
                  'is-invalid': formik.touched.customerTitle && formik.errors.customerTitle,
                })}
                placeholder=''
                {...formik.getFieldProps('customerTitle')}
                disabled={isView}
              />
              {formik.touched.customerTitle && formik.errors.customerTitle && (
                <div className='invalid-feedback' style={{ fontSize: '14px', fontWeight: '500' }}>
                  {formik.errors.customerTitle}
                </div>
              )}
            </div>
            {/* end:: Customer */}

            {/* begin:: Email Customer */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='customerEmail' className='fs-6 mb-1 fw-bold'>
                อีเมลลูกค้า
              </label>

              <input
                className={clsx('form-control form-control-sm', {
                  'is-invalid': formik.touched.customerEmail && formik.errors.customerEmail,
                })}
                placeholder=''
                {...formik.getFieldProps('customerEmail')}
                disabled={isView}
              />
              {formik.touched.customerEmail && formik.errors.customerEmail && (
                <div className='invalid-feedback' style={{ fontSize: '14px', fontWeight: '500' }}>
                  {formik.errors.customerEmail}
                </div>
              )}
            </div>
            {/* end:: Email Customer */}

            <div className='col-12 col-xl-3'>
              <label htmlFor='location' className='fs-6 mb-1 fw-bold'>
                พิกัด
              </label>

              <div className='d-flex flex-row' style={{ columnGap: '12px' }}>
                <div
                  className={clsx({
                    'w-75': !isView,
                    'w-100': isView,
                  })}>
                  <input
                    className={clsx('form-control form-control-sm disabled pointer-events-none', {
                      'is-invalid': formik.touched.latitude && formik.errors.latitude,
                    })}
                    value={`${formik.values.latitude ?? '0.00000'}, ${
                      formik.values.longitude ?? '0.00000'
                    }`}
                    placeholder='กดปุ่มเพื่อเลือกพิกัด'
                    disabled={isView}
                  />
                </div>
                {!isView && (
                  <div className='w-25 d-inline-block'>
                    <button
                      className='btn btn-sm btn-primary w-100'
                      type='button'
                      onClick={handleOpenSelectLocation}>
                      ระบุ
                    </button>
                  </div>
                )}
              </div>

              {formik.touched?.latitude && formik.errors?.latitude && (
                <div className='fv-plugins-message-container mt-2'>
                  <div className='fv-help-block' style={{ fontSize: '14px', fontWeight: '500' }}>
                    {formik.errors?.latitude}
                  </div>
                </div>
              )}
            </div>

            {/* begin:: Address */}
            <div className='col-12 col-xl-12'>
              <label htmlFor='address' className='fs-6 mb-1 fw-bold'>
                ที่อยู่
              </label>

              <textarea
                rows={5}
                className='form-control form-control-sm'
                placeholder=''
                {...formik.getFieldProps('address')}
                disabled={isView}
              />
              {/* 
            {formik.touched?.address && formik.errors?.address && (
              <div className='fv-plugins-message-container mt-2'>
                <div className='fv-help-block'>{formik.errors?.address}</div>
              </div>
            )} */}
            </div>
            {/* end:: Address */}

            {/* begin:: Contact Name */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='contact.name' className='fs-6 mb-1 fw-bold'>
                ชื่อผู้ติดต่อ
                {/* <span className='required' /> */}
              </label>

              <input
                {...formik.getFieldProps('contactPersonFullName')}
                className={clsx('form-control form-control-sm', {
                  'is-invalid':
                    formik.touched.contactPersonFullName && formik.errors.contactPersonFullName,
                })}
                disabled={isView}
              />

              {formik.touched.contactPersonFullName && formik.errors.contactPersonFullName && (
                <div className='fv-plugins-message-container mt-2'>
                  <div className='fv-help-block' style={{ fontSize: '14px', fontWeight: '500' }}>
                    {formik.errors.contactPersonFullName}
                  </div>
                </div>
              )}
            </div>
            {/* end:: Contact Name */}

            {/* begin:: Contact Tel */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='contact.tel' className='fs-6 mb-1 fw-bold'>
                เบอร์โทรศัพท์
                {/* <span className='required' /> */}
              </label>

              <input
                {...formik.getFieldProps('contactPersonPhone')}
                className={clsx('form-control form-control-sm', {
                  'is-invalid':
                    formik.touched.contactPersonPhone && formik.errors.contactPersonPhone,
                })}
                disabled={isView}
              />

              {formik.touched?.contactPersonPhone && formik.errors?.contactPersonPhone && (
                <div className='fv-plugins-message-container mt-2'>
                  <div className='fv-help-block' style={{ fontSize: '14px', fontWeight: '500' }}>
                    {formik.errors?.contactPersonPhone}
                  </div>
                </div>
              )}
            </div>
            {/* end:: Contact Tel */}

            {/* begin:: Engineer Name */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='engineer.name' className='fs-6 mb-1 fw-bold'>
                ชื่อวิศวกรควบคุมงาน
                {/* <span className='required' /> */}
              </label>

              <input
                {...formik.getFieldProps('leadEngineerFullName')}
                className={clsx('form-control form-control-sm', {
                  'is-invalid':
                    formik.touched.leadEngineerFullName && formik.errors.leadEngineerFullName,
                })}
                disabled={isView}
              />

              {formik.touched?.leadEngineerFullName && formik.errors?.leadEngineerFullName && (
                <div className='fv-plugins-message-container mt-2'>
                  <div className='fv-help-block' style={{ fontSize: '14px', fontWeight: '500' }}>
                    {formik.errors?.leadEngineerFullName}
                  </div>
                </div>
              )}
            </div>
            {/* end:: Engineer Name */}

            {/* begin:: Engineer Tel */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='engineer.tel' className='fs-6 mb-1 fw-bold'>
                เบอร์โทรศัพท์
                {/* <span className='required' /> */}
              </label>

              <input
                {...formik.getFieldProps('leadEngineerPhone')}
                className={clsx('form-control form-control-sm', {
                  'is-invalid': formik.touched.leadEngineerPhone && formik.errors.leadEngineerPhone,
                })}
                disabled={isView}
              />

              {formik.touched?.leadEngineerPhone && formik.errors?.leadEngineerPhone && (
                <div className='fv-plugins-message-container mt-2'>
                  <div className='fv-help-block' style={{ fontSize: '14px', fontWeight: '500' }}>
                    {formik.errors?.leadEngineerPhone}
                  </div>
                </div>
              )}
            </div>
            {/* end:: Engineer Tel */}

            {/* begin:: Send Quotation Date */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='date' className='fs-6 mb-1 fw-bold'>
                P2 วันที่ส่งใบเสนอราคา
                {/* <span className='required'></span> */}
              </label>

              <Datetime
                timeFormat={false}
                dateFormat='DD/MM/YYYY'
                renderInput={props => (
                  <input
                    {...props}
                    autoComplete='off'
                    name='sendQuotationDate'
                    className={clsx('form-control form-control-sm', {
                      'is-invalid':
                        formik.touched.sendQuotationDate && formik.errors.sendQuotationDate,
                    })}
                    onBlur={formik.getFieldProps('sendQuotationDate').onBlur}
                    disabled={isView}
                  />
                )}
                onChange={selectedDate => {
                  if (selectedDate)
                    formik.setFieldValue('sendQuotationDate', moment(selectedDate).toDate())
                }}
                value={formik.getFieldProps('sendQuotationDate').value}
              />

              {formik.touched.sendQuotationDate && formik.errors.sendQuotationDate && (
                <div className='fv-plugins-message-container mt-2'>
                  <div className='fv-help-block' style={{ fontSize: '14px', fontWeight: '500' }}>
                    {formik.errors.sendQuotationDate as any}
                  </div>
                </div>
              )}
            </div>
            {/* end:: Send Quotation Date */}

            {/* begin:: Contract Agreed Date */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='date' className='fs-6 mb-1 fw-bold'>
                P3 วันที่ตกลงซื้อขาย
                {/* <span className='required'></span> */}
              </label>

              <Datetime
                timeFormat={false}
                dateFormat='DD/MM/YYYY'
                renderInput={props => (
                  <input
                    {...props}
                    autoComplete='off'
                    name='contractAgreedDate'
                    className={clsx('form-control form-control-sm', {
                      'is-invalid':
                        formik.touched.contractAgreedDate && formik.errors.contractAgreedDate,
                    })}
                    onBlur={formik.getFieldProps('contractAgreedDate').onBlur}
                    disabled={isView}
                  />
                )}
                onChange={selectedDate => {
                  if (selectedDate)
                    formik.setFieldValue('contractAgreedDate', moment(selectedDate).toDate())
                }}
                value={formik.getFieldProps('contractAgreedDate').value}
              />

              {formik.touched.contractAgreedDate && formik.errors.contractAgreedDate && (
                <div className='fv-plugins-message-container mt-2'>
                  <div className='fv-help-block' style={{ fontSize: '14px', fontWeight: '500' }}>
                    {formik.errors.contractAgreedDate as any}
                  </div>
                </div>
              )}
            </div>
            {/* end:: Contract Agreed Date */}

            {/* begin:: Rig To Site Date */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='date' className='fs-6 mb-1 fw-bold'>
                S1 วันที่มี Rig (เครื่องจักร) เข้า Site
                {/* <span className='required'></span> */}
              </label>

              <Datetime
                timeFormat={false}
                dateFormat='DD/MM/YYYY'
                renderInput={props => (
                  <input
                    {...props}
                    autoComplete='off'
                    name='rigToSiteDate'
                    className={clsx('form-control form-control-sm', {
                      'is-invalid': formik.touched.rigToSiteDate && formik.errors.rigToSiteDate,
                    })}
                    onBlur={formik.getFieldProps('rigToSiteDate').onBlur}
                    disabled={isView}
                  />
                )}
                onChange={selectedDate => {
                  if (selectedDate)
                    formik.setFieldValue('rigToSiteDate', moment(selectedDate).toDate())
                }}
                value={formik.getFieldProps('rigToSiteDate').value}
              />

              {formik.touched.rigToSiteDate && formik.errors.rigToSiteDate && (
                <div className='fv-plugins-message-container mt-2'>
                  <div className='fv-help-block' style={{ fontSize: '14px', fontWeight: '500' }}>
                    {formik.errors.rigToSiteDate as any}
                  </div>
                </div>
              )}
            </div>
            {/* end:: Rig To Site Date */}

            {/* begin:: Project Start Date */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='date' className='fs-6 mb-1 fw-bold'>
                S2 วันเริ่มงานที่ยังนับเวลา
                {/* <span className='required'></span> */}
              </label>

              <Datetime
                timeFormat={false}
                dateFormat='DD/MM/YYYY'
                renderInput={props => (
                  <input
                    {...props}
                    autoComplete='off'
                    name='projectStartDate'
                    className={clsx('form-control form-control-sm', {
                      'is-invalid':
                        formik.touched.projectStartDate && formik.errors.projectStartDate,
                    })}
                    onBlur={formik.getFieldProps('projectStartDate').onBlur}
                    disabled={isView}
                  />
                )}
                onChange={selectedDate => {
                  if (selectedDate)
                    formik.setFieldValue('projectStartDate', moment(selectedDate).toDate())
                }}
                value={formik.getFieldProps('projectStartDate').value}
              />

              {formik.touched.projectStartDate && formik.errors.projectStartDate && (
                <div className='fv-plugins-message-container mt-2'>
                  <div className='fv-help-block' style={{ fontSize: '14px', fontWeight: '500' }}>
                    {formik.errors.projectStartDate as any}
                  </div>
                </div>
              )}
            </div>
            {/* end:: Project Start Date */}

            {/* begin:: Project Start Date */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='date' className='fs-6 mb-1 fw-bold'>
                S3 วันที่เริ่มงานโดยเริ่มนับตามสัญญา
                {/* <span className='required'></span> */}
              </label>

              <Datetime
                timeFormat={false}
                dateFormat='DD/MM/YYYY'
                renderInput={props => (
                  <input
                    {...props}
                    autoComplete='off'
                    name='contractStartDate'
                    className={clsx('form-control form-control-sm', {
                      'is-invalid':
                        formik.touched.contractStartDate && formik.errors.contractStartDate,
                    })}
                    onBlur={formik.getFieldProps('contractStartDate').onBlur}
                    disabled={isView}
                  />
                )}
                onChange={selectedDate => {
                  if (selectedDate)
                    formik.setFieldValue('contractStartDate', moment(selectedDate).toDate())
                }}
                value={formik.getFieldProps('contractStartDate').value}
              />

              {formik.touched.contractStartDate && formik.errors.contractStartDate && (
                <div className='fv-plugins-message-container mt-2'>
                  <div className='fv-help-block' style={{ fontSize: '14px', fontWeight: '500' }}>
                    {formik.errors.contractStartDate as any}
                  </div>
                </div>
              )}
            </div>
            {/* end:: Project Start Date */}

            {/* begin:: Last Piled Date */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='date' className='fs-6 mb-1 fw-bold'>
                G1 วันตอกเสาเข็มต้นสุดท้าย
                {/* <span className='required'></span> */}
              </label>

              <Datetime
                timeFormat={false}
                dateFormat='DD/MM/YYYY'
                renderInput={props => (
                  <input
                    {...props}
                    autoComplete='off'
                    name='lastPiledDate'
                    className={clsx('form-control form-control-sm', {
                      'is-invalid': formik.touched.lastPiledDate && formik.errors.lastPiledDate,
                    })}
                    onBlur={formik.getFieldProps('lastPiledDate').onBlur}
                    disabled={isView}
                  />
                )}
                onChange={selectedDate => {
                  if (selectedDate)
                    formik.setFieldValue('lastPiledDate', moment(selectedDate).toDate())
                }}
                value={formik.getFieldProps('lastPiledDate').value}
              />

              {formik.touched.lastPiledDate && formik.errors.lastPiledDate && (
                <div className='fv-plugins-message-container mt-2'>
                  <div className='fv-help-block' style={{ fontSize: '14px', fontWeight: '500' }}>
                    {formik.errors.lastPiledDate as any}
                  </div>
                </div>
              )}
            </div>
            {/* end:: Last Piled Date */}

            {/* begin:: On-site Available Time  */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='date' className='fs-6 mb-1 fw-bold'>
                ช่วงเวลาที่สามารถเข้าหน่วยงานได้
                {/* <span className='required'></span> */}
              </label>

              <input
                {...formik.getFieldProps('onSiteAvailableTime')}
                className={clsx('form-control form-control-sm', {
                  'is-invalid':
                    formik.touched.onSiteAvailableTime && formik.errors.onSiteAvailableTime,
                })}
                disabled={isView}
              />

              {formik.touched?.onSiteAvailableTime && formik.errors?.onSiteAvailableTime && (
                <div className='fv-plugins-message-container mt-2'>
                  <div className='fv-help-block' style={{ fontSize: '14px', fontWeight: '500' }}>
                    {formik.errors?.onSiteAvailableTime}
                  </div>
                </div>
              )}
            </div>
            {/* end:: On-site Available Time  */}

            {/* begin:: Piling Available Time */}
            <div className='col-12 col-xl-3'>
              <label htmlFor='date' className='fs-6 mb-1 fw-bold'>
                ช่วงเวลาที่สามารถลงเสาเข็มได้
                {/* <span className='required'></span> */}
              </label>

              <input
                {...formik.getFieldProps('pilingAvailableTime')}
                className={clsx('form-control form-control-sm', {
                  'is-invalid':
                    formik.touched.pilingAvailableTime && formik.errors.pilingAvailableTime,
                })}
                disabled={isView}
              />

              {formik.touched?.pilingAvailableTime && formik.errors?.pilingAvailableTime && (
                <div className='fv-plugins-message-container mt-2'>
                  <div className='fv-help-block' style={{ fontSize: '14px', fontWeight: '500' }}>
                    {formik.errors?.pilingAvailableTime}
                  </div>
                </div>
              )}
            </div>
            {/* end:: Piling Available Time */}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default SurveyFormHeader
